__webpack_require__.p = "https://school.g-vet.ru/";